import {useMemo} from 'react';
import {getOptions} from '../utils';
import {ColumnData, Row} from '../types';
import {DictionaryItem} from 'utils';

type useTableAutocompleteProps = {
    column: ColumnData;
    dictionary?: DictionaryItem[] | null;
    values: Row;
};

export const useTableAutocomplete = ({column, dictionary, values}: useTableAutocompleteProps) => {
    const isEnumDict = !!column?.enumDict;

    const dictValueKey = isEnumDict ? 'displayName' : column.dictValueKey || 'value';
    const dictIdKey = isEnumDict ? 'code' : column.dictIdKey || 'value';

    const options = useMemo(() => {
        return getOptions({dictionary, column, values});
    }, [dictionary, column, values]);

    const finalOptions: string[] = useMemo(() => {
        // Для enumDict просто получаем все коды
        if (isEnumDict && dictionary) {
            return dictionary.map((item) => String(item[dictIdKey]));
        }

        if (dictIdKey === dictValueKey) {
            // Если значения совпадают, то удаляем дубликаты и собираем данные под ключом dictValueKey
            const res = options.map((el) => String(el[dictValueKey]));
            return Array.from(new Set(res));
        }
        // Если значения не совпадают, то собираем данные под ключом dictIdKey
        return options.map((el) => String(el[dictIdKey]));
    }, [dictIdKey, dictValueKey, options, isEnumDict, dictionary]);

    const getOptionLabel = (option: string) => {
        // Для enumDict ищем displayName по code
        if (isEnumDict) {
            const item = dictionary?.find((el) => String(el[dictIdKey]) === option);
            return item?.[dictValueKey] || option;
        }

        if (dictIdKey === dictValueKey) {
            // Если значения совпадают, то отображаем данные под ключом dictValueKey
            return option;
        }
        // Иначе отображаем данные под ключом dictIdKey
        const optionObj = dictionary?.find((el) => String(el[dictIdKey]) === option);
        return optionObj?.[dictValueKey] || '';
    };

    return {finalOptions, getOptionLabel};
};
